module.exports = __webpack_public_path__ + "static/media/adopets-tiny-logo.8b8e2f4f.ico";